import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
import { Card } from 'react-bootstrap'

import AuthenticatedApp from './AuthenticatedApp';
//import UnauthenticatedApp from './UnauthenticatedApp';
import Message from '../FrontPage/Message'

import ClientLanguage from '../../utils/ClientLanguage';
import LoadingIndicator from '../../components/Layout/LoadingIndicator';
import globalTranslations from "../../translations/translations.json";
import dutchTranslations from "../../translations/nl.translations.json";

import { actionCreators } from '../../store/Navigation';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/default.css';

class App extends Component {

	constructor(props) {
		super(props);
		var clientLanguage = ClientLanguage();

		this.props.initialize({
			languages: [
				{ name: "English", code: "en" },
				{ name: "Dutch", code: "nl" }
			],
			translation: globalTranslations,
			options: {
				renderToStaticMarkup,
				renderInnerHtml: true,
				defaultLanguage: clientLanguage.SingleLanguageCode
			}
		});
		this.props.addTranslationForLanguage(dutchTranslations, "nl");

		this.state = {
			settingsLoaded: false,
			logoUrl: null,
			customStylesheet: null,
			instrumentationKey: null,
		}
	}

	componentDidMount() {
		fetch('/app/publicsettings').then(result => result.json()).then(data => {
			this.setState({ settingsLoaded: true, logoUrl: data.logoUrl, customStylesheet: data.customStylesheet, instrumentationKey: data.instrumentationKey, theme: data.theme, applicationName: data.applicationName, staticHost: data.staticHost });
			document.title = data.applicationName;
			this.addStyle(data.staticHost + "theme.css");
		});
	}

	addStyle = url => {
		const style = document.createElement("link");
		style.href = url;
		style.rel = "stylesheet";
		style.async = true;

		document.head.appendChild(style);
	};

	isAuthenticated() {
		if (!this.props.isAuthorized) {
			//return <Message dangerouslySetInnerHTML={{ __html: this.props.unauthorizedMessage }} />;
			//return <Message errorMessage="Not authorized to view this page" />;
			return (<Card className="">
				<Card.Body dangerouslySetInnerHTML={{ __html: this.props.unauthorizedMessage }} />
			</Card>)
		}

		//if we are authenticated but landing on the logout page this is a wrong redirect. go to the homepage
		if (window.location.pathname === '/logout') {
					window.location = '/';
		}

		this.props.getMenuItems();

		// Use this for custom stylesheet loader (external)
		// {this.state.customStylesheet != null ? <StyleLoader stylesheetPath={this.state.customStylesheet} /> : null }

		return (<div>			
			<AuthenticatedApp logoUrl={this.state.logoUrl} customStylesheet={this.state.customStylesheet} instrumentationKey={this.state.instrumentationKey} />
		</div>);
	}

	isUnAuthenticated() {
		if (window.location.pathname === '/logout') {
			var mesg = (<div>U bent uitgelogd.<br /><br /> <a href="/account/login" className="btn btn-primary" rel="noopener noreferrer nofollow">Log opnieuw in</a></div>);
			return <Message successMessage={mesg} />;
		}
		
		window.location = '/account/login';
		return null;		
	}

	render() {

		let theme = "theme1";

		if (this.state.settingsLoaded) {
			theme = this.state.theme;
		}

		var customTheme = localStorage.getItem('bince-theme');
		if (customTheme !== null) {
			theme = customTheme;
		}

		var appClassName = "PortalApp " + theme;
		appClassName += this.props.isAuthenticated ? "" : " unauth";

		return <div id="app" className={appClassName}>{(!this.props.isLoading && this.state.settingsLoaded) ? this.props.isAuthenticated ? this.isAuthenticated() : this.isUnAuthenticated() : (<LoadingIndicator />)}</div>;		
	}
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.account.isAuthenticated,
		isAuthorized: state.account.isAuthorized,
		unauthorizedMessage: state.account.unauthorizedMessage,
		isLoading: state.account.isLoading
	};
};

export default withRouter(connect(mapStateToProps, dispatch => bindActionCreators({ ...actionCreators }, dispatch))(withLocalize(App)));


// WEBPACK FOOTER //
// ./src/components/App/App.js